module.exports = __webpack_public_path__ + "static/img/img-home-faster_czz.0dcb35bc.png";